/**
 * Anchor to an external site, opened in a new tab with the safe
 * rel="noopener noreferrer". Centralises the styling + security attrs so
 * external links can't drift — or silently lose noopener — across the app.
 */
import type { ReactNode } from 'react';

interface Props {
  href: string;
  children: ReactNode;
  className?: string;
}

export function ExternalLink({
  href,
  children,
  className = 'font-medium text-accent-700 underline',
}: Props) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
      {children}
    </a>
  );
}
